class TeamList {
	constructor() {

		this._editList = new OrderedList();
		this._checkList = new OrderedList(null, 'orderBy', 'chkElem');

		this._dialog = Dialog.Modal('teams', _("Teams"), LARGE, null, [
			this._editList.container,
			this._newButton1 = UI.priIconBtn('plus-square', 22)
		]);
		
		this._popup = Dialog.Popup([
			this._applied = UI.div(),
			this._name = UI.text(
				null,

			),
			this._checkList.container,
			this._newName = UI.div(null, [
				UI.p('smaller', _("Name")),
				this._newNameInput = UI.text(),
				this._newSave = UI.btn('popup-list-btn', _("Save"))
			]),
			this._newButton2 = UI.priIconBtn('plus-square', 22)
		], 'left-start', _("TEAMS")).sticky();
		
		this._newName.style.display = 'none';

		onEv(this._newButton1, 'click', this.newInEdit.bind(this));
		onEv(this._newButton2, 'click', this.newInCheck.bind(this));
		onEv(this._newNameInput, 'paste', event => {
			this._newSave.disabled = event.clipboardData.getData('text').length == 0;
		});
		onEv(this._newNameInput, 'keyup', event => {
			switch (event.keyCode) {
				case AC.ENTER_KEY: this.saveInCheck(); break;
				case AC.ESCAPE_KEY: this.cancelInCheck(); break;
			}
			this._newSave.disabled = this._newNameInput.value === '';
		})

		onEv(this._newSave, 'click', this.saveInCheck.bind(this));
		
		this._selectionIds = null;

		this._activeTeam = null;
		this._filterGroup = false;
		
		this.init();
	}

	set filterGroup(value) {
		this._filterGroup = value;
	}

	get filters() {
		return this._editList.items.map(i => [i.id, i.name]);
	}

	init (){
		API.fetch(
			'teams'
		)
		.then(reply => {
			if (showError(reply)) return;
			if (reply.teams && Array.isArray(reply.teams)) {
				reply.teams.forEach((data) => {
					let team = Team.fromArray(data, this);
					this._editList.addItem(team);
					this._checkList.addItem(team);
				}, this);
				if (this._filterGroup) {
					this._filterGroup.update();
				}
			}
		})
    }

	/**
	 * Opens the edit dialog, to edit / reorder tags or add new ones
	 */
	openDialog() {
		this._selectionIds = null;
		this._dialog.open();
		this._editList.update();
	}

	members(ids, button) {
		this._selectionIds = Array.isArray(ids) ? ids : [ids];

		this._editList.forEach(t => t.reset());
		this._popup.handle(button);

		API.fetch('teams/members')
		.then(reply => {
			if (reply.members) {
				for (let m of reply.members) {
					if (this._selectionIds.indexOf(m.member_id) === -1) continue;
					this._editList.gotoId(m.unit_id).item.increment(this._selectionIds.length);
				}
			}	
		});
	}

	newInEdit () {
		let team = Team.blank(this);
		this._editList.addItem(team, team.getOrder, team.getRow, team.getDrag);
		this._checkList.addItem(team, team.getOrder, team.getChkRow);
		team.edit();
	}

	newInCheck () {
        this._newName.style.display = 'block';
		this._newButton2.style.display = 'none';
		this._newSave.disabled = this._newNameInput.value === '';
		this._newNameInput.select();
    }

	cancelInCheck () {
		this._newNameInput.value = '';
		this.saveInCheck();
	}

	saveInCheck () {
		if (this._newNameInput.value.length) {
			let team = Team.blank(this);
			team.name = this._newNameInput.value;
			this._editList.addItem(team, team.getOrder, team.getRow, team.getDrag);
			this._checkList.addItem(team, team.getOrder, team.getChkRow);
			team.save();
			this._newNameInput.value = '';
		}
		this._newName.style.display = 'none';
		this._newButton2.style.display = 'block';
	}

	remove(team) {
		this._editList.removeItem(team);
		this._checkList.removeItem(team);
	}

	prepDrag(row, ev) {
		if (this._activeTeam !== null) return;
		this._editList.prepDrag(row, ev);
	}
}